export default "__VITE_ASSET__DRypdBOs__"